import axios from "axios";
import api from "../api";

export default {

CREATE_COMMENT: (data) => {
    return new Promise((resolve, reject) => {
        axios
            .post(process.env.REACT_APP_BACKEND_URL + api.comment.CREATE_COMMENT(), data)
            .then((res) => resolve(res))
            .catch((e) => reject(e));
    });
},


CREATE_PROPERTY: (data) => {
    return new Promise((resolve, reject) => {
        axios
            .post(process.env.REACT_APP_BACKEND_URL + api.comment.CREATE_PROPERTY(), data)
            .then((res) => resolve(res))
            .catch((e) => reject(e));
    });
},

GET_COMMENT: () => {
    return new Promise((resolve, reject) => {
        axios
            .get(process.env.REACT_APP_BACKEND_URL + api.comment.GET_COMMENT())
            .then((res) => resolve(res))
            .catch((e) => reject(e));
    });
},
UPDATE_COMMENT: (id,data) => {
    return new Promise((resolve, reject) => {
        axios
            .put(process.env.REACT_APP_BACKEND_URL + api.comment.UPDATE_COMMENT(id),data)
            .then((res) => resolve(res))
            .catch((e) => reject(e));
    });
},
GET_COMMENT_BY_ID: (id) => {
    return new Promise((resolve, reject) => {
        axios
            .get(process.env.REACT_APP_BACKEND_URL + api.comment.GET_COMMENT_BY_ID(id))
            .then((res) => resolve(res))
            .catch((e) => reject(e));
    });
},

GET_ALL_EMAIL_ASSIGN_USER_BY_ID: (id) => {
    return new Promise((resolve, reject) => {
        axios
            .get(process.env.REACT_APP_BACKEND_URL + api.comment.GET_ALL_EMAIL_ASSIGN_USER_BY_ID(id))
            .then((res) => resolve(res))
            .catch((e) => reject(e));
    });
},
DELETE_COMMENT: (id) => {
    return new Promise((resolve, reject) => {
        axios
            .delete(process.env.REACT_APP_BACKEND_URL + api.comment.DELETE_COMMENT(id))
            .then((res) => resolve(res))
            .catch((e) => reject(e));
    });
},
SEND_COMMENT: (data) => {
    return new Promise((resolve, reject) => {
        axios
            .post(process.env.REACT_APP_BACKEND_URL + api.comment.SEND_COMMENT(), data)
            .then((res) => resolve(res))
            .catch((e) => reject(e));
    });
},
}

